import { initialBudgetManagementState, BUDGET_MANAGEMENT_ACTIONS } from './budgetManagement.types'

export function budgetManagementReducer(state = initialBudgetManagementState, { type, payload }) {
  switch (type) {
    case BUDGET_MANAGEMENT_ACTIONS.SET_BUDGET_MANAGEMENT_STATUS:
      return { ...state, status: payload }

    case BUDGET_MANAGEMENT_ACTIONS.SET_BUDGET_MANAGEMENT_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case BUDGET_MANAGEMENT_ACTIONS.SET_BUDGET_MANAGEMENT_DATA:
      return { ...state, data: payload }

    case BUDGET_MANAGEMENT_ACTIONS.CLEAR_BUDGET_MANAGEMENT:
      return initialBudgetManagementState

    default:
      return state
  }
}
